import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  Button,
  Typography,
  Chip,
  IconButton,
  Popover,
  CircularProgress,
  Collapse,
  Divider,
} from "@mui/material";
import CheckRounded from "@mui/icons-material/CheckRounded";
import AccessTimeRounded from "@mui/icons-material/AccessTimeRounded";
import CloudUploadRounded from "@mui/icons-material/CloudUploadRounded";
import InfoRounded from "@mui/icons-material/InfoRounded";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import { RelatedLoad, TripPODResponse } from "../../../types/api";
import documentsIcon from "../../../assets/images/icons/documentsGridIcon.svg";
import { loadsCard } from "../style";
import { useTranslation } from "react-i18next";
import SidebarAddDocumentTimeline from "./timelineAddDocument/SidebarAddDocumentTimeline";
import { useTripDocument } from "../../../context/TripDocumentContext";
import { BlockOutlined, CloseRounded, InfoOutlined } from "@mui/icons-material";
import uploadOutlineIcon from "../../../assets/images/icons/uploadOutline.svg";
import { tripsService } from "../../../api/tripsService/tripsServices";
import { useTripContext } from "../../../context/tripsContext";
import { useAuth } from "../../../utils/hooks/useAuth";
type Props = {
  relatedLoads: RelatedLoad[];
  index: number;
  filteredDocuments: TripPODResponse[];
  tmsLocationRelatedLoad: string;
  tmsLocation: string;
  onDocumentsUpdate?: () => void;
};

export const RelatedLoadsCards: React.FC<Props> = ({
  relatedLoads,
  index,
  filteredDocuments,
  tmsLocationRelatedLoad,
  tmsLocation,
  onDocumentsUpdate,
}) => {
  const { t } = useTranslation();
  const { tripDetails } = useTripContext();
  const { user } = useAuth();

  // Console log per debuggare i dati ricevuti
  useEffect(() => {
    console.log("=== RelatedLoadsCards Complete Debug Info ===", {
      props: {
        relatedLoads,
        index,
        filteredDocuments,
        tmsLocationRelatedLoad,
        tmsLocation,
        onDocumentsUpdate
      },
      relatedLoadsDetails: relatedLoads.map((load, i) => ({
        index: i,
        load,
        loadKeys: Object.keys(load),
        loadValues: Object.values(load)
      })),
      filteredDocumentsDetails: filteredDocuments.map((doc, i) => ({
        index: i,
        doc,
        docKeys: Object.keys(doc),
        docValues: Object.values(doc)
      }))
    });

    // LOG PAYLOAD SIMULATO PER OGNI CARD
    const tmsObjectNumber = tripDetails?.tmsObjectNumber || "FAKE_TMS_OBJECT_NUMBER";
    const userMail = user?.email || "FAKE_USER_EMAIL";
    const docName = "REAL_DOC_NAME.pdf";
    const timestamp = new Date().toISOString().replace("T", " ").split(".")[0] + ".000";
    relatedLoads.forEach((load, i) => {
      console.log(`[DEBUG LOAD STRUCTURE] Card #${i} - Complete load object:`, load);
      console.log(`[DEBUG LOAD STRUCTURE] Card #${i} - All keys:`, Object.keys(load));
      console.log(`[DEBUG LOAD STRUCTURE] Card #${i} - transportOrderTMSKey value:`, (load as any).transportOrderTMSKey);
      
      const concatenated = `${load.tmsLocation}_${tmsLocation}`;
      // Prendi solo la parte finale dopo l'ultimo underscore
      let orderKey = "N/A";
      const transportOrderKey = (load as any).transportOrderTMSKey;
      if (typeof transportOrderKey === 'string' && transportOrderKey.includes('_')) {
        const parts = transportOrderKey.split('_');
        orderKey = parts[parts.length - 1];
      } else if (typeof transportOrderKey === 'string') {
        orderKey = transportOrderKey;
      }
      const payload = {
        document: { bufferIds: ["FAKE_BUFFER_ID"] },
        fields: [
          { value: tmsObjectNumber, name: "TESTO227_131", externalId: "COD_VIAGGIO", className: "AdditionalFieldStringDTO" },
          { value: concatenated, name: "TESTO246_136", externalId: "MITTENTI_DESTINATARI", className: "AdditionalFieldStringDTO" },
          { value: docName, name: "DocName", className: "SubjectFieldDTO" },
          { value: docName, name: "Originale", className: "OriginalFieldDTO" },
          { value: orderKey, name: "TESTO265_131", externalId: "COD_ORDINE", className: "AdditionalFieldStringDTO" },
          { value: timestamp, name: "DATA224_131", externalId: "DATAORAFOTO", className: "AdditionalFieldDateTimeDTO" },
          { value: userMail, name: "TESTO223_131", externalId: "ACCOUNT", className: "AdditionalFieldStringDTO" }
        ]
      };
      console.log(`[SIMULATED UPLOAD PAYLOAD] Card #${i}`, payload);
    });
  }, [relatedLoads, index, filteredDocuments, tmsLocationRelatedLoad, tmsLocation, onDocumentsUpdate]);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [selectedCardData, setSelectedCardData] = useState<any>(null);
  const { getDocumentDetails, fetchLatestPODDoc } = useTripDocument();
  
  const openSidebar = (cardIndex: number) => {
    // Prendi i dati specifici della card cliccata
    const selectedLoad = relatedLoads[cardIndex];
    const { relatedDocs } = documentsByLoad[cardIndex];
    
    const cardData = {
      selectedLoad,
      relatedDocs,
      cardIndex,
      tmsLocationRelatedLoad,
      tmsLocation,
      filteredDocuments
    };
    
    console.log("=== Add POD Button Clicked ===", {
      cardData,
      selectedLoad,
      relatedDocs,
      cardIndex,
      tmsLocationRelatedLoad,
      tmsLocation,
      filteredDocuments
    });
    
    setSelectedCardData(cardData);
    setIsSidebarOpen(true);
  };
  const closeSidebar = (shouldFetchDocuments: boolean) => {
    setIsSidebarOpen(false);
    if (shouldFetchDocuments) {
      // Aggiorna i documenti dopo l'upload
      updateDocuments();
    }
  };

  const updateDocuments = async () => {
    try {
      // Chiama la callback del componente padre per aggiornare i documenti
      if (onDocumentsUpdate) {
        onDocumentsUpdate();
      }
      console.log("Documents updated, triggering re-fetch");
    } catch (error) {
      console.error("Error updating documents:", error);
    }
  };
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [selectedCardDetails, setSelectedCardDetails] = useState<any>(null);

  const [notes, setNotes] = useState<any | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [expandedNotes, setExpandedNotes] = useState<Set<number>>(new Set());

  const toggleNoteExpansion = (noteIndex: number) => {
    const newExpandedNotes = new Set(expandedNotes);
    if (newExpandedNotes.has(noteIndex)) {
      newExpandedNotes.delete(noteIndex);
    } else {
      newExpandedNotes.add(noteIndex);
    }
    setExpandedNotes(newExpandedNotes);
  };

  const fetchNotes = async (documentId: number) => {
    try {
      setLoading(true);
      setError(null);

      const data = await tripsService.getDocumentsNote(documentId);

      if (data.length > 0) {
        setNotes(data); // 👈 Imposta lo stato con tutte le note
      } else {
        setNotes([]); // Nessuna nota disponibile
      }
    } catch (err) {
      setError("Errore nel recupero delle note");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  

  useEffect(() => {
  }, [anchorEl]);

  const handleInfoClick = async (
    event: React.MouseEvent<HTMLButtonElement>,
    documentId: number
  ) => {
    setAnchorEl(event.currentTarget); // Imposta subito anchorEl

    try {
      setLoading(true);
      setError(null);

      const data = await tripsService.getDocumentsNote(documentId);
      if (data.length > 0) {
        setNotes(data); // 👈 Imposta tutte le note invece di solo l'ultima
      } else {
        setNotes([]); // Nessuna nota disponibile
      }
    } catch (err) {
      setError("Errore nel recupero delle note");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleInfoClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const popoverId = open ? "notes-popover" : undefined;

  const handleOpenFilePreview = async (documentId: string) => {
    try {
      // Recupera i dettagli del documento
      const documentDetails = await getDocumentDetails(documentId);

      // Crea un Blob dal binario
      const pdfBlob = new Blob([documentDetails], { type: "application/pdf" });

      // Crea un URL temporaneo per il Blob
      const url = URL.createObjectURL(pdfBlob);

      // Apre il PDF in una nuova scheda
      window.open(url, "_blank");
    } catch (error) {
      console.error(
        "Errore durante il recupero o la visualizzazione del documento:",
        error
      );
    }
  };

  // Pre-calcolo di `relatedDocuments` per ciascun `relatedLoad`
  const documentsByLoad = relatedLoads.map((load, loadIndex) => {
    const relatedDocs = filteredDocuments.filter((doc) => {
      const docLocation = doc.TESTO246_136;
      return docLocation === tmsLocationRelatedLoad + "_" + tmsLocation;
    });

    console.log(`DocumentsByLoad ${loadIndex}:`, {
      load,
      relatedDocs,
      docLocation: tmsLocationRelatedLoad + "_" + tmsLocation,
      documentStatus: relatedDocs[0]?.STATO
    });

    const documentStatus = relatedDocs[0]?.STATO;

    const cardStatus =
      documentStatus === "Profilo Parziale" ||
      documentStatus === "In Verifica" ||
      documentStatus === "In Gestione" ||
      documentStatus === "Rejected"
        ? "to be evaluated"
        : documentStatus === "Gestito" ||
          documentStatus === "Verificata" ||
          documentStatus === "Approvato"
        ? "accepted"
        : documentStatus === "Annullato" || documentStatus === "Errore"
        ? "rejected"
        : "to be uploaded";

    return { relatedDocs, cardStatus };
  });
 

  return (
    <Box sx={loadsCard.wrapper}>
      {relatedLoads.map((load, i) => {
        const { relatedDocs, cardStatus } = documentsByLoad[i];

        return (
          <React.Fragment key={i}>
            <Card
              elevation={0}
              sx={{
                ...loadsCard.card,
                backgroundColor:
                  cardStatus === "to be evaluated"
                    ? "#ffffff"
                    : cardStatus === "accepted"
                    ? "#fafafa"
                    : cardStatus === "rejected"
                    ? "#FFEAED"
                    : "#FFEAED",
              }}
            >
              

              <Box sx={loadsCard.box}>
                {relatedDocs.length > 0 && cardStatus !== "rejected" ? (
                  <>
                    <Box
                      sx={{
                        display: "flex",
                        columnGap: "8px",
                        alignItems: "center",
                      }}
                    >
                      {relatedDocs[0]?.NOTE !== null &&
                        relatedDocs[0]?.NOTE !== "" && (
                          <IconButton
                            onClick={(event) =>
                              handleInfoClick(event, relatedDocs[0]?.DOCNUMBER??-1)
                            }
                            sx={{ padding: 0, margin: 0 }}
                          >
                            <InfoOutlined color="primary" fontSize="small" />
                          </IconButton>
                        )}
                      <Button
                        variant="text"
                        sx={loadsCard.button}
                        onClick={() =>
                          handleOpenFilePreview(
                            String(relatedDocs[0]?.DOCNUMBER || "")
                          )
                        }
                      >
                        {relatedDocs[0]?.DOCNAME?.trim() ||
                          relatedDocs[0]?.ORIGINALE ||
                          "NOME DOCUMENTO"}
                      </Button>
                    </Box>
                    <Box sx={loadsCard.box1}>
                      <Typography sx={loadsCard.loadingPoint}>
                        {t("screens.trips.timeline.loadingPoint")}:
                      </Typography>
                      <Typography sx={loadsCard.loadText}>
                        {load.involvedPartyName || "-"}
                      </Typography>
                    </Box>
                          <Box sx={{display:"flex",flexDirection:"row",columnGap:"8px", justifyContent:"space-between",alignItems:"center"}}>
                    <Chip
                      sx={{
                        backgroundColor:
                          cardStatus === "accepted"
                            ? "#60C589"
                            : "rgb(57 135 226)",
                        ...loadsCard.chips,
                      }}
                      label={
                        <Box sx={loadsCard.labelBox}>
                          {cardStatus === "accepted" ? (
                            <CheckRounded sx={loadsCard.labelIcon} />
                          ) : (
                            <AccessTimeRounded sx={loadsCard.labelIcon} />
                          )}
                          <Typography sx={loadsCard.labelText}>
                            {(() => {
                              const statusTranslations: Record<string, string> =
                                {
                                  "to be evaluated": t(
                                    "screens.trips.approvalStatusDoc.TO_BE_EVALUATED"
                                  ),
                                  accepted: t(
                                    "screens.trips.approvalStatusDoc.ACCEPTED"
                                  ),
                                  rejected: t(
                                    "screens.trips.approvalStatusDoc.REJECTED"
                                  ),
                                  "to be uploaded": t(
                                    "screens.trips.approvalStatusDoc.TO_BE_UPLOADED"
                                  ),
                                };

                              return statusTranslations[cardStatus] || ""; // Fallback per valori non mappati
                            })()}
                          </Typography>
                        </Box>
                      }
                    />
                     {(cardStatus === "accepted" || cardStatus === "rejected") && (
                            <Box
                              sx={{
                                width: "2px",
                                backgroundColor: "text.primary",
                                height: "16px",
                              }}
                            />
                          )}
                                           {(cardStatus === "accepted" || cardStatus === "rejected") && 
                       relatedDocs[0]?.NOTE !== null &&
                       relatedDocs[0]?.NOTE !== "" && (
                             <IconButton
                               onClick={(event) =>
                                 handleInfoClick(event,  relatedDocs[0]?.DOCNUMBER?? -1)
                               }
                               sx={{ padding: 0, margin: 0 }}
                             >
                               <img src={documentsIcon} alt="Documents Icon" />
                             </IconButton>
                           )}
                          </Box>
                  </>
                ) : (
                  <Box sx={loadsCard.box2}>
                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "column",
                        rowGap: "8px",
                      }}
                    >
                      <Box sx={loadsCard.box3}>
                        <Typography sx={loadsCard.loadsText}>
                          {cardStatus === "rejected" ? (
                            <Button
                              variant="text"
                              sx={loadsCard.button}
                              onClick={() =>
                                handleOpenFilePreview(
                                  String(relatedDocs[0]?.DOCNUMBER || "")
                                )
                              }
                            >
                              {relatedDocs[0]?.DOCNAME?.trim() ||
                                relatedDocs[0]?.ORIGINALE ||
                                "NOME DOCUMENTO"}
                            </Button>
                          ) : (
                            t("screens.trips.tripDocuments.podMandatoryUpload")
                          )}
                        </Typography>
                      </Box>

                      <Box sx={loadsCard.box1}>
                        <Typography sx={loadsCard.text}>
                          {t("screens.trips.timeline.loadingPoint")}:
                        </Typography>
                        <Typography sx={loadsCard.loadText}>
                          {load.involvedPartyName || "-"}
                        </Typography>
                      </Box>
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "flex-start",
                          alignItems: "center",
                          columnGap:"8px",
                        }}
                      >
                        <Chip
                          sx={{
                            ...loadsCard.chips1,
                            backgroundColor:
                              cardStatus === "accepted"
                                ? "#60C589"
                                : cardStatus === "rejected"
                                ? "primary.main"
                                : cardStatus === "to be uploaded"
                                ? "rgb(234, 189, 17)"
                                : "rgb(57, 135, 226)",
                          }}
                          label={
                            <Box sx={loadsCard.labelBox}>
                              {cardStatus === "to be uploaded" ? (
                                <img
                                  src={uploadOutlineIcon}
                                  alt="Upload Icon"
                                  style={{ width: "16px", height: "16px" }}
                                />
                              ) : (
                                <BlockOutlined
                                  sx={{ color: "white", fontSize: "14px" }}
                                />
                              )}
                              <Typography sx={loadsCard.text2}>
                                {(() => {
                                  const statusTranslations: Record<
                                    string,
                                    string
                                  > = {
                                    "to be evaluated": t(
                                      "screens.trips.approvalStatusDoc.TO_BE_EVALUATED"
                                    ),
                                    accepted: t(
                                      "screens.trips.approvalStatusDoc.ACCEPTED"
                                    ),
                                    rejected: t(
                                      "screens.trips.approvalStatusDoc.REJECTED"
                                    ),
                                    "to be uploaded": t(
                                      "screens.trips.approvalStatusDoc.TO_BE_UPLOADED"
                                    ),
                                  };

                                  return statusTranslations[cardStatus] || ""; // Fallback per valori non mappati
                                })()}
                              </Typography>
                            </Box>
                          }
                        />
                        {cardStatus === "rejected" && (
                          <Box
                            sx={{
                              width: "2px",
                              backgroundColor: "text.primary",
                              height: "16px",
                            
                            }}
                          />
                        )}
                                                 {cardStatus === "rejected" && 
                          relatedDocs[0]?.NOTE !== null &&
                          relatedDocs[0]?.NOTE !== "" && (
                           <IconButton
                             onClick={(event) =>
                               handleInfoClick(event,  relatedDocs[0]?.DOCNUMBER?? -1)
                             }
                             sx={{ padding: 0, margin: 0 }}
                           >
                             <img src={documentsIcon} alt="Documents Icon" />
                           </IconButton>
                         )}
                      </Box>
                    </Box>

                    <Box>
                      <Button
                        variant="contained"
                        fullWidth
                        sx={loadsCard.podButton}
                        onClick={() => openSidebar(i)}
                      >
                        {t("screens.trips.timeline.addPod")}
                      </Button>
                    </Box>
                  </Box>
                )}
              </Box>
            </Card>
            <Popover
              id={popoverId}
              open={open}
              anchorEl={anchorEl}
              onClose={handleInfoClose}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              slotProps={{
                paper: {
                  sx: {
                    width: 400,
                    minHeight: 300,
                    maxHeight: 300,
                    overflowY: "auto",
                    borderWidth: "1px",
                    borderColor: "primary.main",
                    borderRadius: "10px",
                  },
                },
              }}
            >
              <Box
                sx={{
                  padding: 1.5,
                  height: "100%",
                  position: "relative",
               
                }}
              >
                {/* IconButton per chiudere il Popover */}
                <IconButton
                  onClick={handleInfoClose}
                  sx={{
                    position: "absolute",
                    top: 4,
                    right: 4,
                  }}
                >
                  <CloseRounded />
                </IconButton>

                <Typography
                  variant="h6"
                  sx={{ mb: 1.5, fontWeight: "bold", fontSize: "18px" }}
                >
                  {t("screens.trips.notesCard.notes")}
                </Typography>

                {loading ? (
                  <Box
                    sx={{
                      flex: 1,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <CircularProgress size={24} />
                  </Box>
                ) : error ? (
                  <Typography color="error">{error}</Typography>
                ) : (
                  <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    {Array.isArray(notes) && notes.length > 0 ? (
                      notes.slice().reverse().map((note: any, index: number) => {
                        const isExpanded = expandedNotes.has(index);
                        const shouldShowExpand = note.comment.length > 100;
                        const displayText = shouldShowExpand && !isExpanded 
                          ? note.comment.substring(0, 100) + '...' 
                          : note.comment;

                        return (
                          <Box key={note.id || index}>
                            <Box sx={{ 
                              display: 'flex', 
                              justifyContent: 'space-between', 
                              alignItems: 'flex-start',
                              py: 1
                            }}>
                              <Typography variant="subtitle2" sx={{ fontWeight: 'bold', color: 'primary.main' }}>
                                {t("screens.trips.notesCard.note")} {index + 1}
                              </Typography>
                              {shouldShowExpand && (
                                <IconButton
                                  size="small"
                                  onClick={() => toggleNoteExpansion(index)}
                                  sx={{ padding: 0, margin: 0 }}
                                >
                                  {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                </IconButton>
                              )}
                            </Box>
                            <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', pb: 1 }}>
                              {displayText}
                            </Typography>
                            {index < notes.length - 1 && <Divider sx={{ my: 0.5 }} />}
                          </Box>
                        );
                      })
                    ) : (
                      <Typography variant="body1" sx={{ fontStyle: 'italic', color: 'text.secondary' }}>
                        {t("screens.trips.notesCard.noNotesAvailable")}
                      </Typography>
                    )}
                  </Box>
                )}
              </Box>
            </Popover>
            <SidebarAddDocumentTimeline
              isOpen={isSidebarOpen}
              callbackCloseSidebar={closeSidebar}
              callbackUpdateDocuments={updateDocuments}
              index={index}
              maxIndex={4}
              action={false}
              onDocumentUploaded={onDocumentsUpdate}
              selectedCardData={selectedCardData}
            />
          </React.Fragment>
        );
      })}
    </Box>
  );
};
